<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M15.705 8.25A6.746 6.746 0 0 0 9.75 2.295V.75h-1.5v1.545a6.566 6.566 0 0 0-2.37.728l1.125 1.124a5.246 5.246 0 0 1 6.855 6.84l1.125 1.126c.375-.72.63-1.515.728-2.363h1.537v-1.5h-1.545ZM2.25 3.203l1.53 1.53A6.685 6.685 0 0 0 2.295 8.25H.75v1.5h1.545a6.746 6.746 0 0 0 5.955 5.955v1.545h1.5v-1.545a6.745 6.745 0 0 0 3.518-1.485l1.53 1.53.952-.953L3.203 2.25l-.953.953Zm9.953 9.952a5.246 5.246 0 0 1-7.358-7.357l7.357 7.357Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
